<template>
  <div class="d-flex justify-content-end min-vh-100 pb-5">
    <PreviewSideBar
      :questionnaireOptions="getPart"
      :questionnaireId="questionnaireId"
    />
    <div class="body">
      <CContainer fluid>
        <div class="header">
          <h1>預覽 - {{ title }}</h1>
          <h2>{{ partTitle }}</h2>
        </div>
        <div
          v-for="item in displayList"
          :key="item"
          class="col-10 py-4 mx-auto"
        >
          <div v-if="item.type !== $defines.ItemTypes.Introduction">
            <div class="topic mt-3 d-flex item-title">
              {{ item.itemIndex }}.
              <div class="mx-2 item-title">
                {{ item.title }}
<!--                <span style="color: #e40017; padding-left: 5px">*</span>-->
              </div>
              <CBadge
                color="primary"
                v-if="item.type === 'ChoiceOne'"
                class="ms-2"
                style="height: 30px"
                >單選</CBadge
              >
              <CBadge
                color="primary"
                v-if="item.type === 'ChoiceMultiple'"
                class="ms-2"
                style="height: 30px"
                >複選</CBadge
              >
            </div>
            <p
              v-if="item.description"
              class="remark ms-4"
              style="
                border-top: 1px solid rgba(0, 0, 0, 0.1);
                padding-top: 10px;
              "
            >
              {{ item.description }}
            </p>
          </div>
          <div class="preview-img" v-if="item.image">
            <CImage
              class="mb-4"
              rounded
              thumbnail
              width="200"
              height="200"
              :src="item.image"
              style="cursor: pointer"
              @click.self="enlargeImg = item.part_item_id"
            />
            <img class="enlarge" src="@/assets/icons/enlarge.svg" alt="" />
            <EnLargeImg
              :show="enlargeImg === item.part_item_id"
              :image="item.image"
              @closeImg="enlargeImg = false"
            />
          </div>
          <component
            :is="
              item.type === 'ColumnInput' || item.type === 'Scale'
                ? null
                : ItemTypesMap[item.type]
            "
            :options="item.options"
            :type="item.type"
            :id="item.part_item_id"
            :iconStyle="item.style"
            :star_num="item.star_num"
            :iconList="item.iconList"
            :upperbounds="item.upperbounds"
            :lowerbounds="item.lowerbounds"
            :time_type="item.time_type"
            :info="item"
          />
          <Nest
            v-if="item.type === 'Scale'"
            :info="item"
            :options="item.options"
            :type="item.type"
            :id="item.id"
            :title="item.title"
            :showChild="item.type === '3' ? x && x[item.id] : x && x[item.nest]"
            @isOpen="
              item.type === '3'
                ? (x[item.id] = $event)
                : (x[item.nest] = $event)
            "
          />
          <Form
            v-if="item.type === 'ColumnInput'"
            :info="item"
            :options="item.extension_info"
            :type="item.type"
            :id="item.part_item_id"
            :title="item.title"
            :showChild="
              item.type === '13' ? x && x[item.id] : x && x[item.nest]
            "
            @isOpen="
              item.type === '13'
                ? (x[item.id] = $event)
                : (x[item.nest] = $event)
            "
          />
        </div>
      </CContainer>
    </div>
    <MsgBox
      :show="showMsgBox"
      :errorCode="errorCode"
      :errorMsg="errorMsg"
      @close="showMsgBox = false"
    />
  </div>
</template>
<script>
import MsgBox from '@/components/MsgBox.vue'
import Input from '@/components/Input.vue'
import File from '@/components/File.vue'
import NumberInput from '@/components/NumberInput.vue'
import Radio from '@/components/Radio.vue'
import Nest from '@/components/Nest.vue'
import Form from '@/components/Form.vue'
import RangeBar from '@/components/RangeBar.vue'
import Textarea from '@/components/Textarea.vue'
import CheckBox from '@/components/CheckBox.vue'
import CategoryTitle from '@/components/CategoryTitle.vue'
import Divider from '@/components/Divider.vue'
import Star from '@/components/Star.vue'
import Date from '@/components/Date.vue'
import ItemSort from '@/components/ItemSort.vue'
import EnLargeImg from '@/components/EnLargeImg.vue'
import DynamicForm from '@/components/DynamicForm.vue'
import PreviewSideBar from '@/components/PreviewSideBar.vue'
import { ref, computed } from '@vue/runtime-core'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import useQuestionnaire from '@/composables/useQuestionnaire'
import {
  SAVE_ACTION_NONE,
  ItemTypesMap,
  Part_Is_Display_Yes,
  ItemTypes,
} from '../defines'

export default {
  components: {
    PreviewSideBar,
    Input,
    Radio,
    Nest,
    RangeBar,
    Form,
    Textarea,
    CheckBox,
    NumberInput,
    File,
    CategoryTitle,
    Star,
    Divider,
    ItemSort,
    Date,
    MsgBox,
    EnLargeImg,
    DynamicForm,
  },
  setup() {
    const route = useRoute()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const getPart = ref([])
    const getPartInfo = ref([])
    const title = ref('')
    const partTitle = ref('')
    const enlargeImg = ref(false)
    const questionnaireId = ref('')
    const x = ref({})
    const { getQuestionnaire, questionnairePartInfo } = useQuestionnaire()

    onBeforeRouteUpdate(() => {
      getQue()
    })
    const getNestAndFormId = () => {
      const nestAndFormId =
        getPartInfo.value?.reduce((accu, cur) => {
          if (cur.type === '3' || cur.type === '13') {
            accu[cur.id] = false
          }
          return accu
        }, {}) || {}
      x.value = nestAndFormId
    }
    const getQue = async () => {
      const res = await getQuestionnaire({ id: +route.params.id })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        getPart.value = res.ret.questionnaire.parts
        questionnaireId.value = res.ret.questionnaire.id
        title.value = res.ret.questionnaire.title
        partTitle.value = getPart.value.find((e) => {
          return +e.id === +route.params.part
        })?.title
      }
      const itemList = await questionnairePartInfo({ id: route.params.part })
      if (itemList.error) {
        return
      }
      getPartInfo.value = itemList.ret.info.items || []
      getPartInfo.value.map((e) => (e.action = SAVE_ACTION_NONE))
      getPartInfo.value?.reduce((accu, cur) => {
        if (
          cur.type !== ItemTypes.Introduction &&
          cur.is_display === Part_Is_Display_Yes
        ) {
          cur.itemIndex = accu
          return accu + 1
        } else {
          return accu
        }
      }, 1)
    }
    getQue()
    const displayList = computed(() => {
      return getPartInfo.value.filter(
        (e) => e.is_display === Part_Is_Display_Yes,
      )
    })
    return {
      showMsgBox,
      errorMsg,
      errorCode,
      getQue,
      getPartInfo,
      getPart,
      title,
      enlargeImg,
      partTitle,
      getNestAndFormId,
      questionnaireId,
      displayList,
      x,
      ItemTypesMap,
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
h2 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 33px;
  color: #000000;
}

.body {
  width: calc(100vw - 255px);
  white-space: pre-line;
  padding: 0 40px;
}
.topic {
  font-size: 16px;
}
.remark {
  font-size: 14px;
}
.enlarge {
  width: 20px;
  position: absolute;
  right: 5px;
  bottom: 30px;
  display: none;
}
.preview-img {
  width: 200px;
  position: relative;
  &:hover {
    .enlarge {
      display: block;
    }
  }
}
.item-title {
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 10px;
}
</style>
